<template>
  <div class="container">


    <template v-if="prospect_data_loading">
      Loading
    </template>
    <template v-else>

    <template v-if="prospect_data.is_admin === 1">
      <button class="switch_button" v-on:click="set_account_rep(9)">Julie</button>
      <button class="switch_button" v-on:click="set_account_rep(59)">Rani</button>
      <h3>Prospects {{prospect_data.list_prospect_name}}</h3>
    </template>
    <template v-else>
      <h3>Prospects</h3>
      <button class="new_button" v-on:click="add_new_prospect()">Add New</button>
    </template>

    <div class="row">
      <div class="col-12">
        <table class="table table-striped table-bordered table-hover table-condensed">
          <thead>
          <tr>
            <th>#</th>
            <th>Company</th>
            <th>Progress</th>
            <th>Contact</th>
            <th>City</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="prospect in prospect_data.list" v-bind:key="prospect.id">
            <td style="cursor: pointer; text-decoration: underline" v-on:click="show_prospect_detail_page(prospect.id)">{{prospect.pos}}</td>
            <td>{{prospect.company}}</td>
            <td>{{prospect.progress}}</td>
            <td>{{prospect.contactperson}}</td>
            <td>{{prospect.city}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      account_rep: 0,
      account_rep_default: -1,
    }
  },
  computed: {
    ...mapGetters({
      prospect_data: 'admin/prospect_data',
      prospect_data_loading: 'admin/prospect_data_loading',
    }),
  },
  watch:  {
    prospect_data: async function () {

      this.account_rep = this.prospect_data.account_rep;

      localStorage.setItem('default_agent_prospects', this.account_rep);

      if(this.prospect_data.new_prospect_id > 0) {
        this.$router.push({name: "prospect_detail", 'params':{prospectid: this.prospect_data.new_prospect_id} });
      }
    },
  },
  mounted() {
    if(localStorage.getItem('default_agent_prospects') === null)
    {
      localStorage.setItem('default_agent_prospects', this.account_rep_default);
    }
    else {
      this.account_rep_default = localStorage.getItem('default_agent_prospects');
    }

    this.get_prospect_list();
  },
  methods: {
    set_account_rep(account_rep) {
      this.account_rep_default = account_rep;
      this.$store.dispatch('admin/setProspectField', {fieldname:'get_list',value:this.account_rep_default,'prospectid':0})
    },
    get_prospect_list () {
      this.$store.dispatch('admin/setProspectField', {fieldname:'get_list',value:this.account_rep_default,'prospectid':0})
    },
    show_prospect_detail_page(prospectid) {
      this.$router.push({name: "prospect_detail", 'params':{prospectid: prospectid} });
    },
    add_new_prospect() {
      this.$store.dispatch('admin/setProspectField', {fieldname:'add_new_prospect',value:this.account_rep,'prospectid':0})
    },

  }
}
</script>

<style scoped>

.new_button {
  color: white;
  background-color: green;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  border-radius: 4px;
  border-style: hidden;
  /*font-size: smaller;*/
  font-weight: 700;
  margin-bottom: 10px;
}

.switch_button {
  color: white;
  background-color: blue;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  border-radius: 4px;
  border-style: hidden;
  /*font-size: smaller;*/
  font-weight: 700;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

</style>
